export default {
    title: null,
    detail: null,
    challenge_id: null,
    image: null
}
